import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FaPencilAlt } from "react-icons/fa";
import Dropdown from 'react-bootstrap/Dropdown';
import axios from 'axios';

function ComTable({ caseId, currentComponents, onUpdate }) {
  const [show, setShow] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState('Select Option');
  const [componentValue, setComponentValue] = useState(currentComponents || '');
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  // This effect will update componentValue when currentComponents prop changes
  useEffect(() => {
    setComponentValue(currentComponents || '');
  }, [currentComponents]);

  const handleClose = () => {
    setShow(false);
    setShowSuccessAlert(false);
  };
  
  const handleShow = () => setShow(true);

  const handleSelect = (procedure) => {
    setSelectedProcedure(procedure);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      const response = await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/cases/cases/${caseId}/components`,
        { components: componentValue }
      );

      

      if (response.status === 200 && response.data?.success) {
        setShowSuccessAlert(true);
        
        if (typeof onUpdate === 'function') {
          onUpdate(response.data.data?.components || componentValue);
        }
        
        setTimeout(() => {
          handleClose();
        }, 2000);
      } else {
        throw new Error(response.data?.message || 'Failed to update components');
      }
    } catch (error) {
      console.error('Error updating components:', error);
      alert(error.message || 'Failed to update components');
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = {
    border: '2px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    width: '100%',
    marginTop: '10px'
  };

  const modalBodyStyle = {
    height: '400px',
    overflowY: 'auto',
  };

  const alertStyle = {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 9999,
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '15px',
    borderRadius: '4px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    display: showSuccessAlert ? 'block' : 'none'
  };

  return (
    <div className="App">
      <Button 
        style={{ backgroundColor: '#004aad', borderColor: '#004aad' }} 
        onClick={handleShow}
      >
        <FaPencilAlt style={{ fontSize: '20px' }} />
      </Button>

      {showSuccessAlert && (
        <div style={alertStyle}>
          Components updated successfully!
        </div>
      )}

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header 
          closeButton
          style={{ backgroundColor: '#004aad', borderBottom: '2px solid #ccc' }}
        >
          <Modal.Title style={{ color: 'white', textAlign: "left", display: 'inline-block' }}>
            Edit Components
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={modalBodyStyle}>
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              {selectedProcedure}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleSelect("GUM WORK COMPOSITE")}>
                GUM WORK COMPOSITE
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <div style={{ marginTop: '20px' }}>
            <label htmlFor="components">Components:</label>
            <textarea
              id="components"
              value={componentValue}
              onChange={(e) => setComponentValue(e.target.value)}
              style={inputStyle}
              rows={8}
              placeholder="Enter components details"
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button 
            style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button 
            style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

ComTable.propTypes = {
  caseId: PropTypes.string.isRequired,
  currentComponents: PropTypes.string,
  onUpdate: PropTypes.func
};

ComTable.defaultProps = {
  currentComponents: '',
  onUpdate: () => {}
};

export default ComTable;